import { galleryLoadAnchorListRequest } from 'reactApp/modules/gallery/gallery.module';
import type { Dispatch } from 'redux';

export const onAnchorScroll = (dispatch: Dispatch, anchorId: string, direction: 'up' | 'down') => {
    dispatch(
        galleryLoadAnchorListRequest({
            anchorId,
            direction,
        })
    );
};
